import { FiChevronDown } from 'react-icons/fi';
import styles from './FilterSelect.module.css';

const FilterSelect = ({ label, value, options, onChange }) => {
    return (
        <label className={`${styles.filterPill} d-flex align-items-center gap-2 px-3`}>
            <span className={styles.filterLabel}>{label}</span>
            <select
                className={styles.filterSelect}
                value={value}
                onChange={(event) => onChange(event.target.value)}
            >
                {options.map((option) => (
                    <option key={option}>{option}</option>
                ))}
            </select>
            <FiChevronDown className={styles.filterChevron} />
        </label>
    );
};

export default FilterSelect;
